export const getIP = (req = {}) => (req.headers && req.headers['x-forwarded-for']) || (req.connection && req.connection.remoteAddress)
